// Post-search list-builder findings (spec section 7). Only meaningful once a
// search has run and results (possibly zero) are on screen.
const SPRAY_THRESHOLD = 1000;
const OVERLAP_THRESHOLD = 0.2;

const listBuilderFindings = ({ total = 0, selected = [], selectedCount = null, credits = null, activeList = null, rows = [], dwellReady = false, actions = {} } = {}) => {
  const out = [];
  const sel = Array.isArray(selected) ? selected : [];
  const list = Array.isArray(rows) ? rows : [];

  if (total === 0) {
    out.push({
      tone: "neutral",
      key: "zero_results",
      label: "Loosen the least important filter",
      text: "Nothing matched your filters.",
      actions: actions.loosen ? [{ label: "Loosen the least important filter", run: actions.loosen }] : []
    });
  }

  if (total > SPRAY_THRESHOLD) {
    out.push({
      tone: "neutral",
      key: "spray",
      label: "Narrow to best fit",
      text: `${total.toLocaleString()} results. Narrow to the best fit before revealing.`,
      actions: actions.narrow ? [{ label: "Narrow to best fit", run: actions.narrow }] : []
    });
  }

  const existing = list.filter(r => r?.existing || r?.isExisting || r?.alreadyInSalesgear).length;
  if (list.length && existing / list.length >= OVERLAP_THRESHOLD) {
    out.push({
      tone: "warn",
      key: "overlap_existing",
      label: "Exclude existing",
      text: `${existing} of ${list.length} shown are already in Salesgear.`,
      actions: actions.excludeExisting ? [{ label: "Exclude existing", run: actions.excludeExisting }] : []
    });
  }

  // "Select top N" never fills `selected` -- it records a range, so counting the
  // array alone capped this at one page (50) and the rule could only fire when
  // credits were under 50. Mirror the count the add-to-list path uses.
  const selCount = typeof selectedCount === "number" && selectedCount > 0 ? selectedCount : sel.length;
  if (credits !== null && selCount > credits) {
    out.push({ tone: "bad", key: "over_credits", label: "Reveal will exceed credits", text: `${selCount} selected, ${credits} credits. Select fewer or top up.` });
  }

  if (total > 0 && !activeList && dwellReady) {
    out.push({
      tone: "neutral",
      key: "search_unsaved",
      label: "Save to list",
      text: "You've been looking at this search for a while.",
      actions: actions.saveToList ? [{ label: "Save to list", run: actions.saveToList }] : []
    });
  }

  return out;
};

export default listBuilderFindings;
